import React from "react";

function ProductAttribute({ label, value, unit }) {
  return (
		<div className="single-attr">
			<div className="pretitle">{label}</div>
			<div className="title">
				{value} {unit}
			</div>
		</div>
  );
};

export default ProductAttribute;
